import { createSlice } from '@reduxjs/toolkit';

import endPoints from '../api/endpoint';

import store, { RootState } from './store';

import {
  deleteApiCall,
  getApiCall,
  multiGetApiCallWithDispatch,
  postApiCall,
  putApiCall,
} from '../api/methods';

import { notify } from '../Utils/toastify';

import { ProductionListApiData, ProductionState } from '../types';

import {
  setSelectedEntity,
  setSelectedProduction,
  getUserProfileData,
  setCommonDataLoader,
} from './commonSlice';
import {
  getDashboardRedirectionAccess,
  setDashboardPiechartData,
  setSpendings,
} from './dashboardSlice';
import {
  buildManageEntitiesAccessEndpoint,
  type ManageEntitiesAccessSortType,
} from '../Utils/manageEntitiesAccess';
import { colorsClassNames, colorsNames } from '../Utils/constantData';

const initialState: ProductionState = {
  productiondetails: {},
  departmentlist: {},
  crewmemberlist: {},
  setlist: {},
  documentlist: {},
  contactlist: {},
  crewDoc: {},
  setorder: {},
  orderlist: [],
  episodelist: {},
  productionSpendingGraph: {},
  productionLocations: {},
  productionTableList: {
    productionCount: 0,
    productions: [],
  },
  page: 1,
  graphLoader: false,
  loading: false,
  contacts: [],
  productionFormData: {},
  documentlistdept: {},
  contactlistdept: {},
  setactive: {},
  setinactive: {},
  setcompleted: {},
  setupcoming: {},
  setactiverelated: {},
  setcompletedrelated: {},
  setupcomingrelated: {},
  setlistRelated: {},
  productionsactive: {},
  productionsinactive: {},
  productionsupcoming: {},
  totalProductions: {},
  studiolocations: {},
  studioepisodes: {},
  memberDetails: {},
  loadingmember: {},
  crewListdept: {},
  relatedsets: {},
  departmentDetails: {},
  datePickerStatus: null,
  episodeactive: {},

  episodeinactive: {},
  departmentLoading: false,
  upcomingepisodes: {},
  access: {},
  estimatedActualSpendingGraph: {},
};
const productionSlice = createSlice({
  name: 'production',
  initialState,
  reducers: {
    setProductionDetail: (state, action) => {
      const { payload }: any = action;
      state.productiondetails = payload;
    },
    setMemberDetails: (state, action) => {
      const { payload }: any = action;
      state.memberDetails = payload;
    },
    setDepartmentlist: (state, action) => {
      const { payload }: any = action;
      state.departmentlist = payload;
    },
    setOrderlistings: (state, action) => {
      const { payload }: any = action;
      state.orderlist = payload;
    },
    setStudioLocations: (state, action) => {
      const { payload }: any = action;
      state.studiolocations = payload;
    },
    setStudioEpisodes: (state, action) => {
      const { payload }: any = action;
      state.studioepisodes = payload;
    },
    setSetlist: (state, action) => {
      const { payload }: any = action;
      state.setlist = payload;
    },
    setSetlistRelated: (state, action) => {
      const { payload }: any = action;
      state.setlistRelated = payload;
    },
    setPageNo: (state, action) => {
      const { payload }: any = action;
      state.page = payload;
    },
    setCrewmemberlist: (state, action) => {
      const { payload }: any = action;
      state.crewmemberlist = payload;
    },
    setDocumentlist: (state, action) => {
      const { payload }: any = action;
      state.documentlist = payload;
    },
    setDocumentlistDept: (state, action) => {
      const { payload }: any = action;
      state.documentlistdept = payload;
    },
    // setDocumentlist: (state, action) => {
    //   const { payload }: any = action
    //   state.documentlist = payload
    // },
    setContactlist: (state, action) => {
      const { payload }: any = action;
      state.contactlist = payload;
    },
    setCrewDocCount: (state, action) => {
      const { payload }: any = action;
      state.crewDoc = payload;
    },
    setOrderSetCount: (state, action) => {
      const { payload }: any = action;
      state.setorder = payload;
    },
    setProductionList: (state, action) => {
      const { payload }: { payload: ProductionListApiData } = action;
      state.productionTableList = payload;
    },
    setSetsActive: (state, action) => {
      const { payload }: any = action;
      state.setactive = payload;
    },
    setSetsInactive: (state, action) => {
      const { payload }: any = action;
      state.setinactive = payload;
    },
    setSetsUpcoming: (state, action) => {
      const { payload }: any = action;
      state.setupcoming = payload;
    },
    setActiveEpiodes: (state, action) => {
      const { payload }: any = action;
      state.episodeactive = payload;
    },
    setInactiveEpisodes: (state, action) => {
      const { payload }: any = action;
      state.episodeinactive = payload;
    },
    setUpcomingEpisodes: (state, action) => {
      const { payload }: any = action;
      state.upcomingepisodes = payload;
    },
    setSetsActiveRelated: (state, action) => {
      const { payload }: any = action;
      state.setactiverelated = payload;
    },
    setSetsInactiveRelated: (state, action) => {
      const { payload }: any = action;
      state.setcompletedrelated = payload;
    },
    setSetsUpcomingRelated: (state, action) => {
      const { payload }: any = action;
      state.setupcomingrelated = payload;
    },

    setProdctionSpendingGraph: (state, action) => {
      const { payload }: any = action;
      state.productionSpendingGraph = payload;
    },
    setProdctionLocationList: (state, action) => {
      const { payload }: any = action;
      state.productionLocations = payload;
    },
    setProductionGraphLoader: (state, action) => {
      const { payload }: any = action;
      state.graphLoader = payload;
    },
    setLoading: (state, action) => {
      const { payload }: any = action;
      state.loading = payload;
    },
    setEpisodelist: (state, action) => {
      const { payload }: any = action;
      state.episodelist = payload;
    },
    setProdContactsList: (state, action) => {
      const { payload }: any = action;
      state.contacts = payload;
    },
    setProductionFormDetails: (state, action) => {
      const { payload }: any = action;
      state.productionFormData = payload;
    },
    setContactlistdept: (state, action) => {
      const { payload }: any = action;
      state.contactlistdept = payload;
    },
    setCrewlistdept: (state, action) => {
      const { payload }: any = action;
      state.crewListdept = payload;
    },
    setTotalProductions: (state, action) => {
      const { payload }: any = action;
      state.totalProductions = payload;
    },
    setTotalProductionsActive: (state, action) => {
      const { payload }: any = action;
      state.productionsactive = payload;
    },
    setTotalProductionsUpcoming: (state, action) => {
      const { payload }: any = action;
      state.productionsinactive = payload;
    },
    setTotalProductionsCompleted: (state, action) => {
      const { payload }: any = action;
      state.productionsupcoming = payload;
    },
    setMemberLoading: (state, action) => {
      const { payload }: any = action;
      state.loadingmember = payload;
    },
    setSetlistRelatedSet: (state, action) => {
      const { payload }: any = action;
      state.relatedsets = payload;
    },
    setDepartmentDetail: (state, action) => {
      const { payload }: any = action;
      state.departmentDetails = payload;
    },
    setDatePickerStatus: (state, action) => {
      const { payload }: any = action;
      state.datePickerStatus = payload;
    },
    setDepartmentLoading: (state, action) => {
      const { payload }: any = action;
      state.departmentLoading = payload;
    },
    setAccess: (state, action) => {
      const { payload }: any = action;
      state.access = payload;
    },
    setEstimateActualSpendingGrapgh: (state, action) => {
      const { payload }: any = action;
      state.estimatedActualSpendingGraph = payload;
    },
  },
});

export const {
  setProductionDetail,
  setDepartmentlist,
  setCrewmemberlist,
  setSetlist,
  setMemberLoading,
  setStudioLocations,
  setStudioEpisodes,
  setContactlistdept,
  setDocumentlist,
  setContactlist,
  setCrewDocCount,
  setPageNo,
  setMemberDetails,
  setOrderSetCount,
  setOrderlistings,
  setDocumentlistDept,
  setProductionList,
  setProdctionSpendingGraph,
  setProdctionLocationList,
  setProductionGraphLoader,
  setLoading,
  setEpisodelist,
  setProdContactsList,
  setSetsActive,
  setSetsInactive,
  setSetlistRelated,
  setSetsInactiveRelated,
  setSetsActiveRelated,
  setSetsUpcomingRelated,
  setSetsUpcoming,
  setTotalProductions,
  setTotalProductionsActive,
  setTotalProductionsCompleted,
  setTotalProductionsUpcoming,
  setProductionFormDetails,
  setCrewlistdept,
  setSetlistRelatedSet,
  setDepartmentDetail,
  setDatePickerStatus,
  setActiveEpiodes,
  setInactiveEpisodes,
  setUpcomingEpisodes,
  setDepartmentLoading,
  setAccess,
  setEstimateActualSpendingGrapgh,
} = productionSlice.actions;

export const getProductionDetails = (productionId: any, cb?: any) => {
  const { dispatch } = store;

  dispatch(setLoading(true)); // Show loader before the API call
  dispatch(setMemberLoading(false)); // Show loader before the API call
  getApiCall(
    endPoints.production.productiondetails + productionId,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setProductionDetail(data.data)); // Set the production details
        if (cb) cb(data.data); // Call the callback function if provided
        // dispatch(setSelectedEntity(data.data));
        // dispatch(setSelectedEntityType('production'));
        dispatch(setLoading(false)); // Hide loader after successful response
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      dispatch(setLoading(false)); // Hide loader after error
    },
  );
};

export interface GetMemberDetailOptions {
  entityType?: string;
  entityId?: string;
}

/**
 * Scoped `associated_entities` response is a flat user object with `rolesAndPermissions`
 * (single row). Older UI expects `personalDetails` — mirror identity + permissions there.
 */
function normalizeMemberDetailPayload(raw: any) {
  if (raw == null || typeof raw !== 'object') return raw;
  if (raw.personalDetails) return raw;

  const roleRow = raw.rolesAndPermissions?.[0] ?? raw;
  return {
    ...raw,
    personalDetails: {
      _id: raw.userId ?? raw._id,
      profilePicture: raw.profilePicture,
      firstName: raw.firstName,
      lastName: raw.lastName,
      email: raw.email,
      countryCode: raw.countryCode,
      countryAbbreviation: raw.countryAbbreviation,
      phoneNo: raw.phoneNo,
      rolesAndPermissions: raw.rolesAndPermissions ?? [roleRow],
      financials: raw.financials,
      orderLimit: raw.orderLimit,
      entityType: raw.entityType,
      department: raw.department ?? {
        deptName: raw.departmentName,
      },
      role: raw.role ?? { roleName: raw.roleName },
    },
  };
}

/** Associated-entities / member detail (v2). Optional scope for server filtering. */
export const getMemberDetail = (
  userId?: any,
  cb?: any,
  options?: GetMemberDetailOptions,
) => {
  const { dispatch } = store;

  // Clear previous member details immediately before API call
  // dispatch(setMemberDetails(null));
  dispatch(setMemberLoading(true)); // Show loader before the API call
  let apiEndpoint = endPoints.memberIdDetail;
  if (userId) {
    apiEndpoint += `/${userId}`;
  }
  const qs = new URLSearchParams();
  if (options?.entityType) qs.set('entityType', String(options.entityType));
  if (options?.entityId) qs.set('entityId', String(options.entityId));
  const query = qs.toString() ? `?${qs.toString()}` : '';
  apiEndpoint += query;

  getApiCall(
    apiEndpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setMemberLoading(false)); // Show loader before the API call
        const normalized = normalizeMemberDetailPayload(data.data);
        dispatch(setMemberDetails(normalized)); // Set new details in Redux
        if (cb) cb(normalized); // Call the callback function if provided
      }
    },
    (e: any) => {
      dispatch(setMemberLoading(false)); // Show loader before the API call
      console.error('Error fetching member details:', e);
    },
  );
};

export const getDepartmentList = (
  entityId?: any,
  entityType?: any,
  page?: number | any,
  cb?: any,
  setHasMore?: any,
  isModel?: boolean,
) => {
  const { dispatch } = store;
  const queryParams = [];
  dispatch(setDepartmentLoading(true));
  console.log('entityId', entityId);

  if (entityId) queryParams.push(`entityId=${entityId}`);
  if (entityType) queryParams.push(`entityType=${entityType}`);

  const apiendpoint = `${endPoints.production.departmentList}${
    queryParams.length ? `?${queryParams.join('&')}` : ''
  }`;
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;
      dispatch(setDepartmentLoading(false));
      if (data.data) {
        if (isModel) {
          const currentData = data.data.depts;
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 20; // If less than 10, no more data
            setHasMore(hasMore);
          }
          // cb((prev: any) => [...prev, ...data.data.data])
        } else {
          dispatch(setDepartmentlist(data.data));
        }
      }
    },

    (e: any) => {
      dispatch(setDepartmentLoading(false));
      notify(e?.data?.message, 'error');
    },
  );
};

export const getOrderListProductiondetail = (
  entityId: any,
  entityType: string,
  query?: string | any,
  cb?: any,
  setHasMore?: (hasMore: boolean) => void,
  isModel?: boolean,
  status?: any,
) => {
  const { dispatch } = store;

  const validEntityTypes = [
    'productions',
    'episodes',
    'sets',
    'locations',
    'departments',
    'bookings',
    'studios',
    'universal',
  ];
  if (!validEntityTypes.includes(entityType)) {
    console.error(`entityType must be one of ${validEntityTypes.join(', ')}`);
  }

  // dispatch(setLoading(true))

  // Construct the API endpoint with pagination parameters
  let apiendpoint = `${endPoints.order.orderList}?entityId=${entityId}&entityType=${entityType}${query}`;
  if (status !== undefined && status !== null) {
    apiendpoint += `&status=${status}`;
  }
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      // dispatch(setLoading(false))
      if (data.data) {
        const currentData = data.data.data;
        if (isModel) {
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 10; // If less than 10, no more data
            setHasMore(hasMore);
          }
          // cb((prev: any) => [...prev, ...data.data.data])
        } else {
          dispatch(setOrderlistings(data.data));
        }
      }
    },
    (error: any) => {
      console.error('Error fetching order list:', error);
      // dispatch(setLoading(false))
    },
  );
};

export const getStudioLocationsAll = (
  query: any,
  entityId: any,
  cb?: any,
  setHasMore?: (hasMore: boolean) => void,
  isModel?: boolean,
) => {
  const { dispatch } = store;
  dispatch(setLoading(true));

  // Construct the API endpoint with pagination parameters
  const apiendpoint =
    `${endPoints.studio.studioLocationsAll}${query}` + `&studioId=${entityId}`;

  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      dispatch(setLoading(false));
      if (data.data) {
        const currentData = data.data?.data;
        cb(currentData);

        // Determine if there is more data
        if (setHasMore) {
          const hasMore = currentData.length === 10; // If less than 10, no more data
          setHasMore(hasMore);
        }
        // cb((prev: any) => [...prev, ...data.data.data])
      }
    },
    (error: any) => {
      console.error('Error fetching order list:', error);
      dispatch(setLoading(false));
    },
  );
};
export const getSetLocationsAll = (
  query: any,
  entityId: any,
  cb?: any,
  setHasMore?: (hasMore: boolean) => void,
  isModel?: boolean,
) => {
  const { dispatch } = store;
  dispatch(setLoading(true));

  // Construct the API endpoint with pagination parameters
  const apiendpoint =
    `${endPoints.production.setweblocations}${query}` + `&setId=${entityId}`;

  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      dispatch(setLoading(false));
      if (data.data) {
        const currentData = data.data?.locations;
        cb(currentData);

        // Determine if there is more data
        if (setHasMore) {
          const hasMore = currentData.length === 10; // If less than 10, no more data
          setHasMore(hasMore);
        }
        // cb((prev: any) => [...prev, ...data.data.data])
      }
    },
    (error: any) => {
      console.error('Error fetching order list:', error);
      dispatch(setLoading(false));
    },
  );
};
export const getStudioEpisodesAll = (
  query: any,
  entityId: any,
  cb?: any,
  setHasMore?: (hasMore: boolean) => void,
) => {
  const { dispatch } = store;
  dispatch(setLoading(true));

  // Construct the API endpoint with pagination parameters
  const apiendpoint =
    `${endPoints.studio.studioEpisodesAll}${query}` + `&studioId=${entityId}`;

  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      dispatch(setLoading(false));
      if (data.data) {
        console.log(data.data.data);
        const currentData = data.data.data;

        cb(currentData);

        // Determine if there is more data
        if (setHasMore) {
          const hasMore = currentData.length === 10; // If less than 10, no more data
          setHasMore(hasMore);
        }
        // cb((prev: any) => [...prev, ...data.data.data])
      } else {
        dispatch(setStudioEpisodes(data.data.data));
      }
    },
    (error: any) => {
      console.error('Error fetching order list:', error);
      dispatch(setLoading(false));
    },
  );
};

export const getCrewDocumentCount = (
  entityType: any,
  entityId: any,
  modelEntityId?: any,
  modelEntityType?: any,
  departmentId?: string,
  cb?: any,
) => {
  const { dispatch } = store;
  let apiendpoint = `${endPoints.production.crewdoccount}?entityId=${entityId}&entityType=${entityType}`;

  if (modelEntityId && modelEntityType) {
    apiendpoint = `${apiendpoint}&modelEntityId=${modelEntityId}&modelEntityType=${modelEntityType}`;
  }
  if (departmentId) {
    apiendpoint = `${apiendpoint}&departmentId=${departmentId}`;
  }

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setCrewDocCount(data.data));
        cb(data.data);
      }
    },

    (e: any) => {},
  );
};
export const getSetOrderCount = (entityId: any, type?: string, cb?: any) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  let apiendpoint = endPoints.production.setordercount;

  if (type === 'episode') {
    apiendpoint = `${apiendpoint}?episodeId=${entityId}`;
  } else if (type === 'location') {
    apiendpoint = `${apiendpoint}?locationId=${entityId}`;
  } else if (type === 'set') {
    apiendpoint = `${apiendpoint}?setId=${entityId}`;
  } else {
    apiendpoint = `${apiendpoint}?productionId=${entityId}`;
  }

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setOrderSetCount(data.data));
        cb(data.data);
      }
      // dispatch(setLoading(false))
    },

    (e: any) => {},
  );
};

export const getCrewmemberList = (
  entityType: any,
  modelEntityType: any,
  modelEntityId: any,
  entityId: any,
  userType: any,
  page?: number | any,
  cb?: any,
  setHasMore?: any,
  isModel?: boolean,
  departmentId?: string,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true));

  const apiendpoint =
    `${endPoints.production.crewmemberlist}` +
    `?entityType=${entityType}` +
    `&modelEntityType=${modelEntityType}` +
    `&modelEntityId=${modelEntityId}` +
    `&entityId=${entityId}` +
    `&userType=${userType}` +
    `&page=${page || 1}&limit=10${
      departmentId ? `&departmentId=${departmentId}` : ''
    }`;

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        const currentData = data.data.userPermissions;
        if (isModel) {
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 10; // If less than 10, no more data
            setHasMore(hasMore);
          }
        } else {
          dispatch(setCrewmemberlist(data));
        }
      }
      //  dispatch(setLoading(false)); // Stop the loader
    },
    (e: any) => {
      // console.error('Error fetching crewmember list:', e)
      //   dispatch(setLoading(false)); // Stop the loader in case of error
    },
  );
};

export const getContactsList = (
  entityType: string,
  modelEntityType: string,
  modelEntityId: string | undefined,
  entityId: string | undefined,
  userType: string,
  page?: number | any,
  cb?: any,
  setHasMore?: (hasMore: boolean) => void,
  isModel?: boolean,
  departmentId?: any,
  searchKey?: string,
): void => {
  const { dispatch } = store;

  // Start the loader
  dispatch(setCommonDataLoader(true));

  // Build the API endpoint
  let apiendpoint =
    `${endPoints.production.crewmemberlist}?` +
    `entityType=${entityType}` +
    `&modelEntityType=${modelEntityType}` +
    `&modelEntityId=${modelEntityId}` +
    `&entityId=${entityId}` +
    `&userType=${userType}` +
    `${departmentId ? `&departmentId=${departmentId}` : ''}`;

  if (searchKey) {
    apiendpoint += `&searchKey=${searchKey}`;
  }
  if (page) {
    apiendpoint += `&page=${page || 1}&limit=10`;
  }

  // Make API call
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      if (data?.data) {
        dispatch(setCommonDataLoader(false));
        const currentData = data.data.userPermissions;
        if (isModel) {
          // Callback to append data
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 10; // If less than 10, no more data
            setHasMore(hasMore);
          }
        } else {
          console.log('jnfk', data);
          dispatch(setContactlist(data.data));
        }
      }

      // Stop the loader
      // dispatch(setLoading(false))
    },
    (error: any) => {
      dispatch(setCommonDataLoader(false));
      console.error('Error fetching contacts list:', error);

      // Stop the loader in case of error
      // dispatch(setLoading(false))
    },
  );
};

export const getContactlistDept = (
  entityType: string,
  entityId: string | undefined,
  modelEntityType: string | undefined,
  modelEntityId: string | undefined,
  userType: string,
  page?: number | any,
  cb?: any,
  searchKey?: string,
  setHasMore?: (hasMore: boolean) => void,
  isModel?: boolean,
  departmentId?: string,
): void => {
  const { dispatch } = store;

  // Start the loader
  dispatch(setCommonDataLoader(true));

  // Build the API endpoint
  const apiendpoint =
    `${endPoints.production.crewlistDept}?` +
    `entityType=${entityType}` +
    `&entityId=${entityId}` +
    `${modelEntityType ? `&modelEntityType=${modelEntityType}` : ''}` +
    `${modelEntityId ? `&modelEntityId=${modelEntityId}` : ''}` +
    `&userType=${userType}${
      searchKey ? `&searchKey=${encodeURIComponent(searchKey)}` : ''
    }${departmentId ? `&departmentId=${departmentId}` : ''}`;

  // Make API call
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      dispatch(setCommonDataLoader(false));
      if (data?.data) {
        const currentData = data.data.userPermissions;
        if (isModel) {
          // Callback to append data
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 10; // If less than 10, no more data
            setHasMore(hasMore);
          }
        } else {
          if (userType === 'CONTACT') {
            dispatch(setContactlistdept(data.data));
          } else {
            dispatch(setCrewlistdept(data.data));
          }
        }
      }

      // Stop the loader
      dispatch(setCommonDataLoader(false));
    },
    (error: any) => {
      // console.error('Error fetching contacts list:', error)
      // // Stop the loader in case of error
      dispatch(setCommonDataLoader(false));
      //   notify(error?.data?.message || error?.data?.msg, 'error')
    },
  );
};

export const getManageEntitiesAccess = (
  entityType: string,
  entityId: string | undefined,
  userType: string,
  searchKey?: string,
  sortType?: ManageEntitiesAccessSortType,
): void => {
  if (!entityId) return;

  const { dispatch } = store;

  dispatch(setCommonDataLoader(true));

  getApiCall(
    buildManageEntitiesAccessEndpoint(
      entityType,
      entityId,
      userType as 'CONTACT' | 'CREW_MEMBER',
      searchKey,
      sortType,
    ),
    (response: any) => {
      const { data } = response;
      dispatch(setCommonDataLoader(false));
      if (data?.data) {
        if (userType === 'CONTACT') {
          dispatch(setContactlistdept(data.data));
        } else {
          dispatch(setCrewlistdept(data.data));
        }
      }
    },
    () => {
      dispatch(setCommonDataLoader(false));
    },
  );
};

export type ManageEntityBulkRemoveType = 'full' | 'view_only';

export interface ManageEntityBulkRemovePayload {
  userIds: string[];
  userType: string;
  removeType: ManageEntityBulkRemoveType;
  entityType: string;
  entityId: string;
}

export const bulkRemoveManageEntityAccess = (
  payload: ManageEntityBulkRemovePayload,
  onSuccess?: () => void,
  onError?: () => void,
): void => {
  const { dispatch } = store;

  dispatch(setCommonDataLoader(true));

  deleteApiCall(
    endPoints.manageEntitiesBulkRemoveAccess,
    payload,
    (response: any) => {
      const { data } = response;
      dispatch(setCommonDataLoader(false));

      if (data?.statusCode === 200) {
        notify(data?.message || 'Access removed successfully.', 'success');
        onSuccess?.();
        return;
      }

      notify(data?.message || 'Failed to remove access.', 'error');
      onError?.();
    },
    (error: any) => {
      dispatch(setCommonDataLoader(false));
      notify(error?.data?.message || 'Failed to remove access.', 'error');
      onError?.();
    },
  );
};

export const transferManageEntityOwnership = (
  entityType: string,
  entityId: string,
  newOwnerId: string,
  onSuccess?: () => void,
  onError?: () => void,
): void => {
  const { dispatch } = store;

  dispatch(setCommonDataLoader(true));

  putApiCall(
    endPoints.manageEntitiesTransferOwnership,
    { entityType, entityId, newOwnerId },
    (response: any) => {
      const { data } = response;
      dispatch(setCommonDataLoader(false));

      if (data?.statusCode === 200) {
        notify(
          data?.message || 'Ownership transferred successfully.',
          'success',
        );
        onSuccess?.();
        return;
      }

      notify(data?.message || 'Failed to transfer ownership.', 'error');
      onError?.();
    },
    (error: any) => {
      dispatch(setCommonDataLoader(false));
      notify(error?.data?.message || 'Failed to transfer ownership.', 'error');
      onError?.();
    },
  );
};

export const getSetList = (
  productionId: any,
  page = 1,
  limit = 10,
  cb?: any,
  setHasMore?: (hasMore: boolean) => void,
  isModel?: boolean,
  status?: any,
  searchKey?: string,
  episodeId?: any,
): void => {
  const { dispatch } = store;

  // dispatch(setLoading(true)) // ✅ Prevents duplicate calls

  let apiendpoint = `${endPoints.production.setListWeb}?productionId=${productionId}&page=${page}&limit=${limit}`;
  if (searchKey) apiendpoint += `&searchKey=${encodeURIComponent(searchKey)}`;
  if (status) apiendpoint += `&status=${status}`;
  if (episodeId) apiendpoint += `&episodeId=${episodeId}`;

  getApiCall(
    apiendpoint,
    (response: any) => {
      // dispatch(setLoading(false)) // ✅ Ensure we stop loading when API response is received

      const { data } = response;
      if (!data?.data?.sets) return;

      const currentData = data.data.sets;

      if (isModel) {
        if (cb) cb(currentData); // ✅ Ensure callback is only called once

        if (setHasMore) {
          setHasMore(currentData.length === 10); // ✅ Prevent API from calling indefinitely
        }
      } else {
        // ✅ Dispatch the correct Redux action based on status
        if (status === 'ACTIVE') {
          dispatch(setSetsActive(data.data));
        } else if (status === 'COMPLETED') {
          console.log('completed');
          dispatch(setSetsInactive(data.data));
        } else if (status === 'INACTIVE') {
          dispatch(setSetsUpcoming(data.data));
        } else {
          dispatch(setSetlist(data.data));
        }
      }
    },
    (error: any) => {
      // dispatch(setLoading(false))
      notify(error?.data?.message, 'error');
      console.error('Error fetching set list:', error);
    },
  );
};

export const getAssosiatedSets = (
  setId: any,
  page = 1,
  cb?: any,
  setHasMore?: (hasMore: boolean) => void,
  isModel?: boolean,
  status?: string,
): void => {
  const { dispatch } = store;

  // dispatch(setLoading(true)); // Enable this if needed for loading state

  // Build the API endpoint
  let apiendpoint =
    `${endPoints.location.locationassociatedlist}?locationId=${setId}` +
    `&page=${page}&limit=8`;

  if (status) apiendpoint += `&status=${status}`;

  // Make API call
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      if (!data?.data?.sets) return;

      const currentData = data.data.sets;

      if (isModel) {
        cb?.(currentData);

        if (setHasMore) {
          setHasMore(currentData.length === 10); // If less than 10, no more data
        }
      } else {
        // Dispatch the correct Redux action based on status
        if (status === 'ACTIVE') {
          dispatch(setSetsActiveRelated(data.data));
        } else if (status === 'COMPLETED') {
          dispatch(setSetsInactiveRelated(data.data));
        } else if (status === 'INACTIVE') {
          dispatch(setSetsUpcomingRelated(data.data));
        } else {
          dispatch(setSetlistRelated(data.data));
        }
      }

      // dispatch(setLoading(false)); // Enable if needed
    },
    (error: any) => {
      console.error('Error fetching set list:', error);
      // dispatch(setLoading(false)); // Enable if needed
    },
  );
};
export const getTotalProduction = (
  queryParams: any,
  setId: any,
  page = 1,
  cb?: any,
  status?: string | any,
  isCount?: string | boolean,
): void => {
  const { dispatch } = store;

  dispatch(setLoading(true)); // Enable this if needed for loading state

  // Build the API endpoint
  let apiendpoint =
    `${endPoints.studio.studioProductions}` +
    `${queryParams}&studioId=${setId}`;

  if (status) apiendpoint += `&status=${status}`;

  // Make API call
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      dispatch(setLoading(false)); // Enable if needed

      const currentData = data.data.productions;
      const count = data?.data?.productionCount;
      cb && isCount ? cb(count) : cb(currentData);

      if (status === 'ACTIVE') {
        dispatch(setTotalProductionsActive(data.data));
      } else if (status === 'COMPLETED') {
        dispatch(setTotalProductionsCompleted(data.data));
      } else if (status === 'INACTIVE') {
        dispatch(setTotalProductionsUpcoming(data.data));
      } else {
        dispatch(setTotalProductions(data.data));
      }
    },
    (error: any) => {
      console.error('Error fetching set list:', error);
      dispatch(setLoading(false)); // Enable if needed
    },
  );
};

export const getTotalSetsStudio = (
  queryParams: any,
  setId: any,
  page = 1,
  cb?: any,
  // setHasMore?: (hasMore: boolean) => void,
  // isModel?: boolean,
  status?: string,
): void => {
  const { dispatch } = store;

  // dispatch(setLoading(true)); // Enable this if needed for loading state

  // Build the API endpoint
  let apiendpoint =
    `${endPoints.studio.studiosets}` + `${queryParams}&studioId=${setId}`;

  if (status) apiendpoint += `&status=${status}`;

  // Make API call
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      console.log(data?.data, 'data');
      // if (!data?.data?.sets) return;

      const currentData = data.data.productions;
      cb && cb(currentData);
      // if (isModel) {
      //   cb?.(currentData);

      //   if (setHasMore) {
      //     setHasMore(currentData.length === 10); // If less than 10, no more data
      //   }
      // } else {
      // Dispatch the correct Redux action based on status
      if (status === 'ACTIVE') {
        dispatch(setTotalProductionsActive(data.data));
      } else if (status === 'COMPLETED') {
        dispatch(setTotalProductionsCompleted(data.data));
      } else if (status === 'INACTIVE') {
        dispatch(setTotalProductionsUpcoming(data.data));
      } else {
        dispatch(setTotalProductions(data.data));
      }
    },

    // dispatch(setLoading(false)); // Enable if needed
    // }
    (error: any) => {
      console.error('Error fetching set list:', error);
      // dispatch(setLoading(false)); // Enable if needed
    },
  );
};

export const getRelatedSetList = (
  setId: any,
  page = 1,
  cb?: any,
  setHasMore?: (hasMore: boolean) => void,
  isModel?: boolean,
): void => {
  const { dispatch } = store;

  // Start the loader
  // dispatch(setLoading(true))

  // Build the API endpoint
  const apiendpoint =
    `${endPoints.location.locationsetslist}?locationId=${setId}` +
    `&page=${page}&limit=10`;

  // Make API call
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      if (data?.data) {
        const currentData = data.data.sets;
        if (isModel) {
          cb(currentData);
          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 10; // If less than 10, no more data
            setHasMore(hasMore);
          }
        } else {
          dispatch(setSetlistRelatedSet(data.data));
        }
      }

      // dispatch(setLoading(false))
    },
    (error: any) => {
      console.error('Error fetching set list:', error);

      // dispatch(setLoading(false))
    },
  );
};

export const getDocumentlist = (
  entityId?: string | undefined,
  entityType?: string,
  page?: number | any,
  cb?: any,
  setHasMore?: any,
  isModel?: boolean,
  deptId?: any,
  productionId?: any,
  setLoading?: any,
  searchKey?: string,
  modelEntityType?: string,
  modelEntityId?: string,
) => {
  if (setLoading) {
    setLoading(true);
  }

  const { dispatch } = store;
  const apiendpoint =
    // Keep query minimal:
    // page/limit + entityType/entityId + modelEntityType/modelEntityId (+ optional searchKey)
    `${endPoints.production.documentlist}?page=${page || 1}&limit=10${
      entityId ? `&entityId=${entityId}` : ''
    }${entityType ? `&entityType=${entityType}` : ''}${
      searchKey ? `&searchKey=${encodeURIComponent(searchKey)}` : ''
    }` +
    `${modelEntityType ? `&modelEntityType=${modelEntityType}` : ''}` +
    `${modelEntityId ? `&modelEntityId=${modelEntityId}` : ''}`;

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        if (setLoading) {
          setLoading(false);
        }
        const currentData = data.data.docs;
        if (isModel) {
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 10; // If less than 10, no more data
            setHasMore(hasMore);
          }
        } else {
          dispatch(setDocumentlist(data.data));
        }
      }
      // dispatch(setLoading(false)) // Stop the loader
    },
    (e: any) => {
      if (setLoading) {
        setLoading(false);
      }
      console.error('Error fetching document list:', e);
      //    dispatch(setLoading(false)) // Stop the loader in case of error
    },
  );
};

export const getDocumentlistDeptWise = (
  entityId: string | undefined,
  entityType: string,
  page?: number | any,
  searchKey?: string,
  cb?: any,
  setHasMore?: any,
  isModel?: boolean,
  limit?: number,
  setListLoading?: (loading: boolean) => void,
) => {
  const { dispatch } = store;

  if (isModel) {
    setListLoading?.(true);
  } else {
    dispatch(setCommonDataLoader(true));
  }

  const apiendpoint = `${
    endPoints.production.documentlisrDept
  }?entityId=${entityId}&entityType=${entityType}&page=${page || 1}&limit=${
    limit || 10
  }${searchKey ? `&searchKey=${encodeURIComponent(searchKey)}` : ''}`;

  getApiCall(
    apiendpoint,
    (s: any) => {
      if (isModel) {
        setListLoading?.(false);
      } else {
        dispatch(setCommonDataLoader(false));
      }
      const { data } = s;
      if (data.data) {
        const currentData = data.data.docs;
        if (isModel) {
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const pageNum = Number(page || 1);
            const pageLimit = Number(limit || 10);
            const isGroupedByDepartment =
              currentData &&
              typeof currentData === 'object' &&
              !Array.isArray(currentData);

            // If API returns docs grouped by department name, pagination is by department groups
            // (keys), not by total document rows.
            if (isGroupedByDepartment) {
              const deptGroupsReturned = Object.keys(currentData || {}).length;
              const deptTotal =
                Number(data?.data?.deptCount) ||
                Number(data?.data?.departmentCount) ||
                Number(data?.data?.groupCount) ||
                0;

              if (deptTotal > 0) {
                setHasMore(pageNum * pageLimit < deptTotal);
              } else {
                // Fallback: if we got a full page of department groups, assume there may be more.
                setHasMore(deptGroupsReturned >= pageLimit);
              }
            } else {
              // Flat list: paginate by documents
              const total =
                Number(data?.data?.docCount) ||
                Number(data?.data?.total) ||
                Number(data?.data?.totalCount) ||
                0;
              const returnedDocs = Array.isArray(currentData)
                ? currentData.length
                : 0;

              if (total > 0) {
                setHasMore(pageNum * pageLimit < total);
              } else {
                setHasMore(returnedDocs >= pageLimit);
              }
            }
          }
        } else {
          dispatch(setDocumentlistDept(data.data));
        }
      }
    },
    (e: any) => {
      if (isModel) {
        setListLoading?.(false);
      } else {
        dispatch(setCommonDataLoader(false));
      }
      console.error('Error fetching document list:', e);
    },
  );
};

export const getProductionTableData = (
  currentPage = 1,
  limit = 10,
  searchKey = '',
  cb?: any,
) => {
  const { dispatch } = store;
  dispatch(setLoading(true));
  const url = searchKey
    ? endPoints.productionListweb(currentPage, limit, searchKey)
    : endPoints.productionListweb(currentPage, limit);
  getApiCall(
    url,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setLoading(false));
        dispatch(setProductionList(data.data));
        cb(data.data);
      }
      dispatch(setLoading(false));
    },

    (e: any) => {},
  );
};

export const getProductionSpendingGraph = (
  type: string,
  id: string,
  range: string,
  productionId?: string,
  cb?: any,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  dispatch(setProductionGraphLoader(true));

  // console.log('Graph =>>', type, id, range)

  // Build the API endpoint with the query and studioId
  let apiendpoint = endPoints.production.spendingGraph(type, id, range);

  if (productionId) {
    apiendpoint = `${apiendpoint}&productionId=${productionId}`;
  }

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // Check the status value and dispatch the appropriate action
        // console.log('data', data)
        dispatch(setProdctionSpendingGraph(data?.data));

        cb(data.data);
      }

      // Stop loading indicator
      // dispatch(setLoading(false))
      dispatch(setProductionGraphLoader(false));
    },
    (e: any) => {
      // Handle error, stop loading
      // dispatch(setLoading(false))
      dispatch(setProductionGraphLoader(false));
    },
  );
};

export const getProductionLocationList = (
  productionId: string,
  urlParam?: any,
  cb?: any,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))

  const apiendpoint = `${urlParam}?productionId=${productionId}`;

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // Check the status value and dispatch the appropriate action
        // console.log('data', data)
        dispatch(setProdctionLocationList(data?.data));

        cb(data.data);
      }

      // Stop loading indicator
      // dispatch(setLoading(false))
    },
    (e: any) => {
      // Handle error, stop loading
      // dispatch(setLoading(false))
    },
  );
};

export const getEpisodeListings = (
  setId: any,
  page = 1,
  limit?: any,
  cb?: any,
  setHasMore?: (hasMore: boolean) => void,
  isModel?: boolean,
  status?: any,
): void => {
  const { dispatch } = store;
  // dispatch(setLoading(true))

  // Build the API endpoint
  let apiendpoint =
    `${endPoints.production.episodelist}?productionId=${setId}` +
    `&page=${page}&limit=${limit || 10}`;
  if (status) apiendpoint += `&status=${status}`;
  // API call
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      if (data?.data) {
        const currentData = data.data.episodes;

        if (isModel) {
          if (cb) cb(currentData); // ✅ Ensure callback is only called once

          if (setHasMore) {
            setHasMore(currentData.length === 10); // ✅ Prevent API from calling indefinitely
          }
        } else {
          // ✅ Dispatch the correct Redux action based on status
          if (status === 'ACTIVE') {
            dispatch(setActiveEpiodes(data.data));
          } else if (status === 'COMPLETED') {
            console.log('completed');
            dispatch(setInactiveEpisodes(data.data));
          } else if (status === 'INACTIVE') {
            dispatch(setUpcomingEpisodes(data.data));
          } else {
            dispatch(setEpisodelist(data.data));
          }
        }
      }
      // dispatch(setLoading(false))
    },
    (error: any) => {
      console.error('Error fetching episode list:', error);
      // dispatch(setLoading(false))
    },
  );
};

export const updateContactsList = (data: any) => {
  const { dispatch } = store;

  const contacts = store.getState().production.contacts;

  console.log(contacts, 'lwbdkjwvbjfkdvwkjvfk');

  dispatch(setProdContactsList([...contacts, data]));
};

export const removeContactsList = (data: any) => {
  const { dispatch } = store;

  // const contacts = store.getState().production.contacts

  // console.log(contacts)

  dispatch(setProdContactsList(data));
};

export default productionSlice.reducer;

export const addProduction = (values: any, callback: any) => {
  return (dispatch: any, getState: () => RootState) => {
    // const payload = {
    //   userType: userType,
    //   status: status,
    // }
    // dispatch(getProductionList({ loading: true }))
    console.log('======>>>>APIIII');

    postApiCall(
      endPoints.productionManagement.createProduction,
      values,

      (s: any) => {
        const {
          data: { statusCode, data, message },
        } = s;
        if (statusCode === 400 && message) {
          notify(message, 'error');
          return;
        }
        if (statusCode && statusCode === 200) {
          console.log({ data }, 'ttt');
          // notify(s?.data.message, 'success')
          // dispatch(getProductionList())
          callback(data);
        }
        getDashboardRedirectionAccess();
        getUserProfileData();
        // dispatch(getProductionList({ loading: false }))

        // dispatch(updateVendorManagement(false))
      },
      (e: any) => {
        //   setLoad(false)
        // dispatch(updateVendorManagement(false))
        // dispatch(getProductionList({ loading: false }))
        callback();
        if (e?.data && e?.data.message) {
          notify(e?.data.message, 'error');
        }
      },
    );
  };
};

export const updateProductionFormDetails = (data: any) => {
  const { dispatch } = store;

  const contacts = store.getState().production.contacts;

  console.log(contacts);

  dispatch(setProductionFormDetails(data));
};

export const updateProduction = (id: string, values: any, callback: any) => {
  return (dispatch: any, getState: () => RootState) => {
    putApiCall(
      endPoints.production.productionUpdate(id),
      values,

      (s: any) => {
        const {
          data: { statusCode, data, message },
        } = s;
        if (statusCode === 400 && message) {
          notify(message, 'error');
          return;
        }
        if (statusCode && statusCode === 200) {
          console.log({ data }, 'ttt');
          notify(message, 'success');
          // dispatch(getProductionList())

          callback();
        }
        // dispatch(getProductionList({ loading: false }))

        // dispatch(updateVendorManagement(false))
      },
      (e: any) => {
        //   setLoad(false)
        // dispatch(updateVendorManagement(false))
        // dispatch(getProductionList({ loading: false }))
        callback();
        if (e?.data && e?.data.message) {
          notify(e?.data.message, 'error');
        }
      },
    );
  };
};

export const getTotalSets = (
  queryParams: any,
  setId: any,
  page = 1,
  cb?: any,
  // setHasMore?: (hasMore: boolean) => void,
  // isModel?: boolean,
  status?: string,
  isCount?: any,
): void => {
  const { dispatch } = store;

  dispatch(setCommonDataLoader(true)); // Enable this if needed for loading state

  // Build the API endpoint
  let apiendpoint =
    `${endPoints.production.totalSets}` + `${queryParams}&studioId=${setId}`;

  if (status) apiendpoint += `&status=${status}`;

  // Make API call
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;
      dispatch(setCommonDataLoader(false));
      // if (!data?.data?.sets) return;

      const currentData = data?.data?.data;
      const count = data?.data?.total;
      cb && isCount ? cb(count) : cb(currentData);
      // if (isModel) {
      //   cb?.(currentData);

      //   if (setHasMore) {
      //     setHasMore(currentData.length === 10); // If less than 10, no more data
      //   }
      // } else {
      // Dispatch the correct Redux action based on status
      if (status === 'ACTIVE') {
        dispatch(setTotalProductionsActive(data.data));
      } else if (status === 'COMPLETED') {
        dispatch(setTotalProductionsCompleted(data.data));
      } else if (status === 'INACTIVE') {
        dispatch(setTotalProductionsUpcoming(data.data));
      } else {
        dispatch(setTotalProductions(data.data));
      }
    },

    // dispatch(setLoading(false)); // Enable if needed
    // }
    (error: any) => {
      console.error('Error fetching set list:', error);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const getDepartmentDetails = (deptId: any, cb?: any) => {
  const { dispatch } = store;

  dispatch(setLoading(true)); // Show loader before the API call

  getApiCall(
    endPoints.deptDetail + deptId,
    (s: any) => {
      dispatch(setLoading(false)); // Show loader before the API call

      const { data } = s;
      if (data.data) {
        dispatch(setDepartmentDetail(data.data)); // Set the production details
        if (cb) cb(data.data); // Call the callback function if provided
        dispatch(setLoading(false)); // Hide loader after successful response
      }
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      dispatch(setLoading(false)); // Hide loader after error
    },
  );
};

export const updateDepartment = (
  deptId: string,
  values: any,
  cb?: () => void,
  onError?: () => void, // 👈 add this
) => {
  putApiCall(
    `${endPoints.updateDept}${deptId}`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (statusCode && statusCode === 200) {
        if (cb) cb();
        notify(message, 'success');
      }
    },
    (e: any) => {
      if (e?.data?.message) {
        notify(e.data.message, 'error');
      }
      if (onError) onError(); // 👈 call it here
    },
  );
};

export const updateDatePicker = (status: boolean) => {
  const { dispatch } = store;

  dispatch(setDatePickerStatus(status));
};

//----------------------- -- -- - - -- -Code for optimise the api with promise.all method. --- -- -- -- -- - -- - - -- - -- -- -

export const fetchProductionMetaData = async (productionId: string) => {
  const { dispatch } = store;

  dispatch(setLoading(true));

  const calls: any = [
    {
      url: endPoints.production.productiondetails + productionId,
      dispatchFn: setProductionDetail,
      cb: (data: any) => {
        dispatch(setSelectedProduction(data));
        dispatch(setSelectedEntity(data));
      },
    },
  ];

  await multiGetApiCallWithDispatch(calls, dispatch)
    .catch(err => {
      console.error('Error in multi API dispatch:', err);
    })
    .finally(() => {
      dispatch(setLoading(false));
    });
};

// utils/parallelApi.ts
export const callParallelApis = async (
  tasks: (() => Promise<any>)[],
  onComplete?: (results: any[]) => void,
) => {
  try {
    const results = await Promise.all(tasks.map(fn => fn()));
    onComplete?.(results);
  } catch (error) {
    console.error('Error in parallel API calls:', error);
  }
};

// 1. Production Details
export const fetchProductionDetails = (productionId: string): Promise<any> => {
  const { dispatch } = store;

  dispatch(setLoading(true));
  dispatch(setMemberLoading(false));

  return new Promise((resolve, reject) => {
    getApiCall(
      endPoints.production.productiondetails + productionId,
      (res: any) => {
        const { data } = res;
        if (data?.data) {
          dispatch(setProductionDetail(data.data));
          resolve(data.data);
        } else reject('No data');
        dispatch(setLoading(false));
      },
      (err: any) => {
        dispatch(setLoading(false));
        reject(err);
      },
    );
  });
};

export const fetchSetOrderCount = (productionId: string): Promise<any> => {
  const { dispatch } = store;

  return new Promise((resolve, reject) => {
    const apiendpoint = `${endPoints.production.setordercount}?productionId=${productionId}`;
    getApiCall(
      apiendpoint,
      (res: any) => {
        const { data } = res;
        if (data?.data) {
          dispatch(setOrderSetCount(data.data));
          resolve(data.data);
        } else reject('No data');
      },
      (err: any) => reject(err),
    );
  });
};

export const fetchCrewDocCount = (
  entityId: string,
  modelEntityId: string,
  modelEntityType: string,
): Promise<any> => {
  const { dispatch } = store;
  const url = `${endPoints.production.crewdoccount}?entityId=${entityId}&entityType=productions&modelEntityId=${modelEntityId}&modelEntityType=${modelEntityType}`;
  return new Promise((resolve, reject) => {
    getApiCall(
      url,
      (res: any) => {
        const { data } = res;
        if (data?.data) {
          dispatch(setCrewDocCount(data.data));
          resolve(data.data);
        } else reject('No data');
      },
      (err: any) => reject(err),
    );
  });
};

export const fetchProductionLocationList = (
  productionId: string,
): Promise<any> => {
  const { dispatch } = store;

  return new Promise((resolve, reject) => {
    const apiendpoint = `${endPoints.production.locationList}?productionId=${productionId}`;
    getApiCall(
      apiendpoint,
      (res: any) => {
        const { data } = res;
        if (data?.data) {
          dispatch(setProdctionLocationList(data.data));
          resolve(data.data);
        } else reject('No data');
      },
      (err: any) => reject(err),
    );
  });
};

export const fetchSpendings = (type: string, id: string): Promise<any> => {
  const { dispatch } = store;

  dispatch(setCommonDataLoader(true));

  return new Promise((resolve, reject) => {
    const endPoint = `${endPoints.dashBoard.spendings}?entityType=${type}&entityId=${id}`;

    getApiCall(
      endPoint,
      (res: any) => {
        const { data } = res;
        if (data?.data) {
          dispatch(setSpendings(data.data));
          resolve(data.data);
        } else reject('No data');
        dispatch(setCommonDataLoader(false));
      },
      (err: any) => {
        dispatch(setCommonDataLoader(false));
        notify(err?.data?.message, 'error');
        reject(err);
      },
    );
  });
};

export const checkAccess = (type: string, id: string) => {
  const { dispatch } = store;

  const endPoint = `${endPoints.notification.checkAccess}?entityType=${type}&entityId=${id}`;

  getApiCall(
    endPoint,
    (res: any) => {
      const { data } = res;
      if (data) {
        dispatch(setAccess(data));
      }
    },
    (err: any) => {
      console.error('Error fetching access:', err);
    },
  );
};

export const checkEntityAccess = (
  type: string,
  id: string,
  cb?: (data: any) => void,
) => {
  const { dispatch } = store;

  const endPoint = `${endPoints.notification.checkAccessV2}?entityType=${type}&entityId=${id}`;

  getApiCall(
    endPoint,
    (res: any) => {
      const { data } = res;
      if (data) {
        dispatch(setAccess(data));
        cb?.(data?.data);
        // cb?.(data);
      }
    },
    (err: any) => {
      console.error('Error fetching entity access:', err);
    },
  );
};

export const getDepartmentSetOrderCount = (
  entityId: any,
  modelEntityId?: string,
  modelEntityType?: string,
  departmentId?: string,
  cb?: any,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  let apiendpoint = endPoints.production.setordercount;

  apiendpoint = `${apiendpoint}?productionId=${entityId}`;

  if (modelEntityId) {
    apiendpoint = `${apiendpoint}&modelEntityId=${modelEntityId}`;
  }
  if (modelEntityType) {
    apiendpoint = `${apiendpoint}&modelEntityType=${modelEntityType}`;
  }
  if (departmentId) {
    apiendpoint = `${apiendpoint}&departmentId=${departmentId}`;
  }
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setOrderSetCount(data.data));
        cb(data.data);
      }
      // dispatch(setLoading(false))
    },

    (e: any) => {},
  );
};

export const getEstimateActualSpendingGraph = (
  entityId: string,
  entityType: string,
  fromDate?: number,
  toDate?: number,
  departmentId?: string,
  productionId?: string,
  setId?: string,
  locationId?: string,
  episodeId?: string,
  productionScheduleType?: string,
  setScheduleType?: string,
  categoryId?: string,
  vendorId?: string,
  productId?: string,
  quickSelect?: string,
  itemNickName?: string,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  dispatch(setProductionGraphLoader(true));

  // console.log('Graph =>>', type, id, range)

  // Build the API endpoint with the query and studioId
  let apiendpoint = `${endPoints.actualEstimateGraph}?entityId=${entityId}&entityType=${entityType}`;

  if (fromDate) {
    apiendpoint = `${apiendpoint}&fromDate=${fromDate}`;
  }

  if (toDate) {
    apiendpoint = `${apiendpoint}&toDate=${toDate}`;
  }

  if (departmentId) {
    apiendpoint = `${apiendpoint}&departmentId=${departmentId}`;
  }

  if (productionId) {
    apiendpoint = `${apiendpoint}&productionId=${productionId}`;
  }

  if (setId) {
    apiendpoint = `${apiendpoint}&setId=${setId}`;
  }

  if (locationId) {
    apiendpoint = `${apiendpoint}&locationId=${locationId}`;
  }

  if (episodeId) {
    apiendpoint = `${apiendpoint}&episodeId=${episodeId}`;
  }

  if (productionScheduleType) {
    apiendpoint = `${apiendpoint}&productionScheduleType=${productionScheduleType}`;
  }

  if (setScheduleType) {
    apiendpoint = `${apiendpoint}&setScheduleType=${setScheduleType}`;
  }

  if (categoryId) {
    apiendpoint = `${apiendpoint}&categoryId=${categoryId}`;
  }

  if (vendorId) {
    apiendpoint = `${apiendpoint}&vendorId=${vendorId}`;
  }

  if (productId) {
    apiendpoint = `${apiendpoint}&productId=${productId}`;
  }

  if (quickSelect) {
    apiendpoint = `${apiendpoint}&quickSelect=${quickSelect}`;
  }
  if (itemNickName) {
    apiendpoint = `${apiendpoint}&itemNickName=${itemNickName}`;
  }

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        // Check the status value and dispatch the appropriate action
        // console.log('data', data)
        dispatch(setEstimateActualSpendingGrapgh(data?.data));
        dispatch(
          setDashboardPiechartData(
            [
              ...data.data?.pieChart?.topFiveSpendings,
              ...data.data?.pieChart?.others,
            ]?.map((item: any, i: number) => ({
              ...item,
              className: colorsClassNames[i],
              color: colorsNames[i],
            })),
          ),
        );
      }

      // Stop loading indicator
      // dispatch(setLoading(false))
      dispatch(setProductionGraphLoader(false));
    },
    (e: any) => {
      // Handle error, stop loading
      // dispatch(setLoading(false))
      dispatch(setProductionGraphLoader(false));
    },
  );
};
